import { useEffect, useState, type RefObject } from 'react';

export function useElementWidth(elementRef: RefObject<HTMLElement | null>): number | undefined {
  const [widthPx, setWidthPx] = useState<number>();

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    const observer = new ResizeObserver(([entry]) => {
      if (entry) setWidthPx(entry.contentRect.width);
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [elementRef]);

  return widthPx;
}
